import { render, staticRenderFns } from "./producer_data_card.vue?vue&type=template&id=3f529006&scoped=true"
import script from "./producer_data_card.vue?vue&type=script&lang=js"
export * from "./producer_data_card.vue?vue&type=script&lang=js"
import style0 from "./producer_data_card.vue?vue&type=style&index=0&id=3f529006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f529006",
  null
  
)

export default component.exports